module.exports = __webpack_public_path__ + "img/close.48256f4d.png";